import React from "react";

/** See also: icon 'user' */
export const profile = () => {
  return (
    <svg width="26px" height="24px" viewBox="0 0 26 24">
      <g stroke="none" strokeWidth="1" fill="none">
        <g transform="translate(-948.000000, -49.000000)" fill="currentColor">
          <g id="Side-and-top" transform="translate(-1.000000, 0.000000)">
            <g id="Profile-Copy" transform="translate(949.000000, 49.000000)">
              <g id="User" transform="translate(0.931034, 0.903226)">
                <path
                  d="M12.5517241,14.516129 C15.7437241,14.516129 18.3448276,11.2620968 18.3448276,7.25806452 C18.3448276,3.25403226 15.7437241,0 12.5517241,0 C9.35972414,0 6.75862069,3.25403226 6.75862069,7.25806452 C6.75862069,11.2620968 9.36551724,14.516129 12.5517241,14.516129 Z M12.5517241,1.81451613 C14.7936552,1.81451613 16.6068966,4.23387097 16.6068966,7.25806452 C16.6068966,10.2822581 14.7936552,12.7016129 12.5517241,12.7016129 C10.3097931,12.7016129 8.49655172,10.2822581 8.49655172,7.25806452 C8.49655172,4.23387097 10.3097931,1.81451613 12.5517241,1.81451613 Z"
                  id="Shape"
                ></path>
                <path
                  d="M17.4558452,13.5527973 C16.9681254,13.5046874 16.5332128,13.8556947 16.4844408,14.336794 C16.4356688,14.8178933 16.7915064,15.2469022 17.2792262,15.2950122 C20.0180111,15.612468 22.1398614,17.8079721 22.3305299,20.521657 L1.80740118,20.521657 C2.01609301,17.8158485 4.12875634,15.6298503 6.85870479,15.2950122 C7.34642472,15.2469023 7.70226232,14.8178934 7.65349033,14.336794 C7.60471834,13.8556946 7.16980571,13.5046873 6.68208579,13.5527973 C6.61732548,13.5527973 0,14.2961423 0,21.3869571 C0,21.8680564 0.395375116,22.2580645 0.883095038,22.2580645 L23.254836,22.2580645 C23.7425559,22.2580645 24.137931,21.8680564 24.137931,21.3869571 C24.137931,14.2961423 17.5206056,13.5527973 17.4558452,13.5527973 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
